import { useEffect, type ReactNode } from 'react';
import type { IcpItem } from '@nest-recruit/shared';
import { IcpFormGroups, useIcpForm, type BudgetNote, type IcpFormState } from './IcpProfileForm';
import styles from './icp.module.css';

// ADR 0062 §4, mockup M1: the profile form drawn in the page it belongs to — job setup and the role template editor — not in the
// docked panel. The lines are the same four groups; what sits under them (Save, the cost) is the page's to say.

interface IcpInlineFormProps {
  readonly defaultItems: readonly IcpItem[];
  readonly notes: readonly string[];
  readonly isRemote: boolean;
  readonly budget: BudgetNote;
  readonly onChange: (items: readonly IcpItem[]) => void;
  /** Whether the lines pass the same checks the server makes, so a page can keep its own Save off until they do. */
  readonly onValidChange?: (isValid: boolean) => void;
  /** What sits under the lines; given the form's state (can it be saved, how many lines Jev reads). */
  readonly footer?: (state: IcpFormState) => ReactNode;
}

export function IcpInlineForm({ defaultItems, notes, isRemote, budget, onChange, onValidChange, footer }: IcpInlineFormProps): ReactNode {
  const state = useIcpForm({ defaultItems, isRemote, onChange });
  const isValid = state.canSave;
  useEffect(() => {
    onValidChange?.(isValid);
  }, [isValid, onValidChange]);

  return (
    <>
      <div className={styles.setupBody}>
        <IcpFormGroups state={state} notes={notes} isRemote={isRemote} budget={budget} />
      </div>
      {footer && <div className={styles.setupFoot}>{footer(state)}</div>}
    </>
  );
}
